import EditVisibility from 'components/drawers/EditCompanyVisibility';

const Form = ({ drawer, active, editType }) => {
  return editType === 'visibility' ? (
    <EditVisibility active={active} drawer={drawer} isOpen={drawer.isOpen} type="fuel-grades" />
  ) : null;
};

export default Form;
